import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue, useState } from "react";
import { inBrowser } from "@lilib/utils";
import useEventListener from "./useEventListener";
function useWindowSize() {
  var _useState = useState(function () {
      if (inBrowser) {
        return {
          width: window.innerWidth,
          height: window.innerHeight
        };
      } else {
        return {
          width: undefined,
          height: undefined
        };
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    width = _useState2$.width,
    height = _useState2$.height,
    setState = _useState2[1];
  function listener() {
    setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }
  useEventListener(function () {
    return window;
  }, "resize", listener);
  useEventListener(function () {
    return window;
  }, "orientationchange", listener);
  useDebugValue({
    width: width,
    height: height
  });
  return {
    width: width,
    height: height
  };
}
export default useWindowSize;